module.exports = __webpack_public_path__ + "media/app/assets/imgs/event_archive_logo_colored-a9b934048b16bfa427675eb8c0d56bbd.svg";